import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListComponent } from './list.component';
import { FormModule } from "../../default/form/form.module";
import { NoResultsModule } from "../../default/no-results/no-results.module";
import { AngularMaterialModule } from "../../../../core/angular-material/angular-material.module";
import { AvatarModule } from "../../default/avatar/avatar.module";
import { TranslateModule } from "@ngx-translate/core";
import { DirectivesModule } from "../../../directives/directives.module";
import { ProgressSpinnerModule } from "../../default/progress-spinner/progress-spinner.module";
import { NgxMaskModule } from "ngx-mask";
import { PipesModule } from "../../../pipes/pipes.module";


@NgModule({
    declarations: [
        ListComponent
    ],
    imports: [
        CommonModule,
        FormModule,
        NoResultsModule,
        AngularMaterialModule,
        AvatarModule,
        TranslateModule,
        ProgressSpinnerModule,
        NgxMaskModule,
        DirectivesModule,
        PipesModule

    ],
    exports: [
        ListComponent
    ]
})
export class ListModule {
}
